module.exports = __webpack_public_path__ + "img/man-action.dc1ceda8.svg";